import React, { useEffect, useState } from 'react'
import { IconButton } from '@mui/material';
import { SubmitButton as Button } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import PhoneInput from 'components/common/PhoneInput';
import { Controller, useFormContext } from 'react-hook-form';

const DynamicDepartments = ({ item }) => {
    const { control, formState: { errors }, watch, setValue } = useFormContext();
    const [dynamicArray, setDynamicArray] = useState([]);
    const [communicationPoc, setCommunicationPoc] = useState({});
    console.log(communicationPoc, 'communicationPoc');

    console.log(watch("departments"), 'departments watch');

    useEffect(() => {
        setDynamicArray(watch("departments") || []);
    }, [watch("departments")]);

    const handleAdd = React.useCallback(() => {
        setDynamicArray(prevArray => {
            const newVariants = [...prevArray, {
                id: null,
                name: "",
                billing_email: "",
                contact_person_name: "",
                is_communication_poc: communicationPoc[prevArray.length] ? true : false,
                poc_name: communicationPoc[prevArray.length] ? "" : undefined,
                poc_email: communicationPoc[prevArray.length] ? "" : undefined,
                poc_phone: communicationPoc[prevArray.length] ? "" : undefined,
            }];

            setValue("departments", newVariants);
            return newVariants;
        });
    }, [setValue, communicationPoc]);

    const handleRemove = (index) => {
        const newVariants = [...dynamicArray];
        newVariants.splice(index, 1);

        const newCommunicationPoc = {};
        newVariants.forEach((_, i) => {
            newCommunicationPoc[i] = communicationPoc[i >= index ? i + 1 : i] || false;
        });

        setDynamicArray(newVariants);
        setCommunicationPoc(newCommunicationPoc);
        setValue("departments", newVariants);
    };

    const handleCommunicationPocToggle = (index) => {
        setCommunicationPoc(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));

        setDynamicArray(prevArray => {
            const newVariants = [...prevArray];

            if (communicationPoc[index]) {
                newVariants[index] = {
                    ...newVariants[index],
                    is_communication_poc: false,
                    // poc_name: undefined,
                    // poc_email: undefined,
                    // poc_phone: undefined,
                };
            } else {
                newVariants[index] = {
                    ...newVariants[index],
                    is_communication_poc: true,
                };
            }

            setValue("departments", newVariants);
            return newVariants;
        });
    };

    // Prefill from item.departments in edit mode (same pattern as facilities' item effect)
    useEffect(() => {
        const newState = {};
        if (item?.departments) {
            item.departments.forEach((dept, idx) => {
                if (dept.is_communication_poc) {
                    newState[idx] = true;
                }
            });
        }

        const formattedDepartments = (item?.departments || []).map((val, index) => ({
            id: val?.id,
            name: val?.name || '',
            billing_email: val?.billing_email || '',
            contact_person_name: val?.contact_person_name || '',
            is_communication_poc: newState[index] == true,
            poc_name: newState[index] == true ? val?.poc_name : undefined,
            poc_email: newState[index] == true ? val?.poc_email : undefined,
            poc_phone: newState[index] == true ? val?.poc_phone : undefined,
        }));

        setValue('departments', formattedDepartments);
        setCommunicationPoc(newState);

    }, [item?.departments]);

    return (
        <>
            <hr />
            <div className="row-primary row-r justify-content-between flex-row">
                <h2 className='fst-italic'>Departments</h2>
                <Button btnText='Add' buttonType='button' handleSubmit={handleAdd} />
            </div>

            {dynamicArray?.map((val, index) => {
                return (
                    <div className='w-100 biling_info' key={index}>
                        <div className='d-flex gap-1'>
                            <div className="row-primary w-100 align-items-center">
                                <h2>Department Name *</h2>
                                <div className='w-100'>
                                    <Controller
                                        name={`departments.${index}.name`}
                                        control={control}
                                        rules={{
                                            required: "Please enter department name"
                                        }}
                                        render={({ field }) => (
                                            <input className="input-in type_inp"
                                                type="text"
                                                name={`departments.${index}.name`}
                                                placeholder='Name'
                                                {...field}
                                            />
                                        )}
                                    />
                                    {
                                        errors?.departments?.length && errors?.departments[index]?.name?.message &&
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={errors?.departments[index]?.name?.message} />
                                        </div>
                                    }
                                </div>
                            </div>
                            {dynamicArray?.length > 0 && (
                                <IconButton className="mb-3" color='error'
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        marginLeft: "auto",
                                    }}
                                    onClick={() => handleRemove(index)}
                                >
                                    <i className="fa-solid fa-trash-can trash_icon"></i>
                                </IconButton>
                            )}
                        </div>

                        <div className='foam_page_row'>
                            <div className="row-primary">
                                <h2>Billing Email *</h2>
                                <div className='w-100'>
                                    <Controller
                                        name={`departments.${index}.billing_email`}
                                        control={control}
                                        rules={{
                                            required: "Please enter billing email",
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                message: "Please enter a valid email"
                                            }
                                        }}
                                        render={({ field }) => (
                                            <input className="input-in type_inp"
                                                type="email"
                                                autoComplete="off"
                                                name={`departments.${index}.billing_email`}
                                                placeholder='Billing Email'
                                                {...field}
                                            />
                                        )}
                                    />
                                    {
                                        errors?.departments?.length && errors?.departments[index]?.billing_email?.message &&
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={errors?.departments[index]?.billing_email?.message} />
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="row-primary">
                                <h2>Contact Person Name</h2>
                                <div className='w-100'>
                                    <Controller
                                        name={`departments.${index}.contact_person_name`}
                                        control={control}
                                        render={({ field }) => (
                                            <input className="input-in type_inp"
                                                type="text"
                                                name={`departments.${index}.contact_person_name`}
                                                placeholder='Contact Person Name'
                                                {...field}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row-primary align-items-center">
                            <h2></h2>
                            <h2 className='m-0'>Is this the Communication POC?</h2>
                            <label className="custom-checkbox checkbox">
                                <input
                                    type="checkbox"
                                    name={`departments.${index}.is_communication_poc`}
                                    checked={communicationPoc[index] || false}
                                    onChange={() => handleCommunicationPocToggle(index)}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>

                        {communicationPoc[index] && (
                            <div className='foam_page_row'>
                                <div className="row-primary">
                                    <h2>POC Name *</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name={`departments.${index}.poc_name`}
                                            control={control}
                                            rules={{
                                                required: "Please enter POC name"
                                            }}
                                            render={({ field }) => (
                                                <input className="input-in type_inp"
                                                    type="text"
                                                    name={`departments.${index}.poc_name`}
                                                    placeholder='POC Name'
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {
                                            errors?.departments?.length && errors?.departments[index]?.poc_name?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.departments[index]?.poc_name?.message} />
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="row-primary">
                                    <h2>POC Email *</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name={`departments.${index}.poc_email`}
                                            control={control}
                                            rules={{
                                                required: "Please enter POC email",
                                                pattern: {
                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                    message: "Please enter a valid email"
                                                }
                                            }}
                                            render={({ field }) => (
                                                <input className="input-in type_inp"
                                                    type="email"
                                                    autoComplete="off"
                                                    name={`departments.${index}.poc_email`}
                                                    placeholder='POC Email'
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {
                                            errors?.departments?.length && errors?.departments[index]?.poc_email?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.departments[index]?.poc_email?.message} />
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="row-primary">
                                    <h2>POC Phone</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name={`departments.${index}.poc_phone`}
                                            control={control}
                                            render={({ field }) => (
                                                <PhoneInput
                                                    className="input-in type_inp"
                                                    type="tel"
                                                    name={`departments.${index}.poc_phone`}
                                                    placeholder='POC Phone number'
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {
                                            errors?.departments?.length && errors?.departments[index]?.poc_phone?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.departments[index]?.poc_phone?.message} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                        <hr />
                    </div>
                )
            })}
            <br />
        </>
    )
};

export default DynamicDepartments;